import { render, staticRenderFns } from "./FilesView.vue?vue&type=template&id=68f43584&scoped=true&"
import script from "./FilesView.vue?vue&type=script&lang=js&"
export * from "./FilesView.vue?vue&type=script&lang=js&"
import style0 from "./FilesView.vue?vue&type=style&index=0&id=68f43584&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f43584",
  null
  
)

export default component.exports